import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { EntityRenewalService } from '../entity-renewal.service';
import { StartFunctionService } from '../../../shared/utils/start-function.service';
import { StorageService } from '../../../shared/security/StorageService';
import { CurrentPageWatcherService } from '../../../shared/utils/CurrentPageWatcher';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { QuestionnaireQuestionModel } from '../../../model/questionnaireQuestionModel';
import { SelectInactiveOfficesToRenewRequestModel } from '../../../model/selectInactiveOfficesToRenewRequestModel';
import * as $ from 'jquery';
import { SelectInactiveOfficesToRenewResponseModel } from '../../../model/selectInactiveOfficesToRenewResponseModel';
import { MessageModel } from '../../../model/models';
import { SubmitQuestionnaireAnswersRequestModel } from '../../../model/submitQuestionnaireAnswersRequestModel';
import { StartFunctionResponseModel } from '../../../model/startFunctionResponseModel';
import { WorkflowModel } from '../../../model/workflowModel';
import { QuestionnaireAnswerModel } from '../../../model/questionnaireAnswerModel';
import { SubmitQuestionnaireAnswersResponseModel } from '../../../model/submitQuestionnaireAnswersResponseModel';
import { SectionTextModel } from '../../../model/sectionTextModel';
import { SectionContentModel } from '../../../model/sectionContentModel';
import { SubmitIndividualCorporationStatusResponseModel } from '../../../model/submitIndividualCorporationStatusResponseModel';
import { IndividualRenewalService } from '../../individual-renewal/individual-renewal.service';

@Component({
  selector: 'app-questionnaire-verify-entity-renewal',
  templateUrl: './questionnaire-verify-entity-renewal.component.html',
  styleUrls: ['./questionnaire-verify-entity-renewal.component.css']
})
export class QuestionnaireVerifyEntityRenewalComponent implements OnInit , OnDestroy{
  

  notifyEntityQuestionListSubscription = new Subscription();
  notifyIndividualQuestionListSubscription = new Subscription();
  
  entityRenewalQuestions: Array<QuestionnaireQuestionModel> = [];
  individualRenewalQuestions: Array<QuestionnaireQuestionModel> = [];

  startFunction: StartFunctionResponseModel = {};
  workflow: WorkflowModel = new WorkflowModel();
  notifyInactiveOfficesToRenewRequestSubscription = new Subscription();
  selectInactiveOfficesToRenewResponseModel: SelectInactiveOfficesToRenewResponseModel = new SelectInactiveOfficesToRenewResponseModel();
  submitQuestionnaireAnswersRequestModel: SubmitQuestionnaireAnswersRequestModel = new SubmitQuestionnaireAnswersRequestModel();
  agree: boolean = false;
  userMessages: Array<MessageModel> = [];
  headerContent : SectionContentModel = new SectionContentModel;
  notifyIndividualCorporationStatusResponseSubscription = new Subscription();
  individualCorporationStatusResponse : SubmitIndividualCorporationStatusResponseModel =new SubmitIndividualCorporationStatusResponseModel();

  notifySubmitQuestionnaireAnswersSubscription: Subscription = new Subscription();
  submitQuestionnaireAnswersResponseModel: SubmitQuestionnaireAnswersResponseModel = new SubmitQuestionnaireAnswersResponseModel();

  constructor(private entityRenewalService: EntityRenewalService,
    private individualRenewalService : IndividualRenewalService,
    private startFunctionService: StartFunctionService,
    private storage: StorageService,
    private currentPageWatcher: CurrentPageWatcherService,
    private router: Router) {


    this.notifyIndividualCorporationStatusResponseSubscription=this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().subscribe(
      (data: SubmitIndividualCorporationStatusResponseModel)=>{
        this.individualCorporationStatusResponse=data;
      }
    );

    this.currentPageWatcher.displayUserMessage = false;


    let textModel : SectionTextModel = new SectionTextModel();
    textModel.text="Please verify that the following answers are correct. To change the answer to any of the questions, select the \"Back\" button below. If correct, please click the box indicating that you certify to their correctness and then press the \"Continue\" button.";
    this.headerContent.textList.push(textModel);

    this.currentPageWatcher.sendHeaderContent(this.headerContent);

  
    this.entityRenewalQuestions = this.entityRenewalService.questionnaireQuestionModel;
    

    this.individualRenewalQuestions = this.individualRenewalService.questionnaireQuestionModel;

    this.notifyInactiveOfficesToRenewRequestSubscription = this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel()
      .subscribe(selectInactiveOfficesToRenewResp => {
        this.selectInactiveOfficesToRenewResponseModel = selectInactiveOfficesToRenewResp;

        // if (this.selectInactiveOfficesToRenewResponseModel == null) {
        //   this.workflow = this.startFunction.Workflow;
        // }

        // else {
        //   this.workflow = this.selectInactiveOfficesToRenewResponseModel.Workflow;
        // }      

      });

      this.notifySubmitQuestionnaireAnswersSubscription = this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().subscribe(submitQuestionnaireAnswersResp => {
        this.submitQuestionnaireAnswersResponseModel = submitQuestionnaireAnswersResp;
      });
  }

  ngOnInit() {
    this.startFunction = this.storage.getStartFunctionData();

    if(this.entityRenewalService.renewalWorkflowModel == undefined || this.entityRenewalService.renewalWorkflowModel==null){
      this.workflow = this.startFunction.Workflow;
    }
    else{
      this.workflow = this.entityRenewalService.renewalWorkflowModel;
    }
    // if(this.selectInactiveOfficesToRenewResponseModel.Workflow==null && this.individualCorporationStatusResponse.Workflow==null){
    //   this.workflow = this.startFunction.Workflow;
    // }
    // if(this.selectInactiveOfficesToRenewResponseModel.Workflow!=null) {
    //   this.workflow = this.selectInactiveOfficesToRenewResponseModel.Workflow;
    // }
    // if(this.selectInactiveOfficesToRenewResponseModel.Workflow==null && this.individualCorporationStatusResponse.Workflow!=null) {
    //   this.workflow = this.individualCorporationStatusResponse.Workflow;
    // }
    
    this.submitQuestionnaireAnswersRequestModel.WorkflowID = this.workflow.WorkflowID;
    this.submitQuestionnaireAnswersRequestModel.CurrentStepIndex = this.workflow.CurrentStepIndex
  }

  continue() {
    this.currentPageWatcher.clearUserMessage();
    this.currentPageWatcher.clearHeaderContent();
    if (this.agree == false) {
      let userMessage: MessageModel = {};
      userMessage.Alert = 3;
      userMessage.Description = "You must check the box below to continue.";
      this.userMessages.push(userMessage);
      $("html, body").animate({ scrollTop: 0 }, "slow");
      this.currentPageWatcher.sendUserMessages(this.userMessages);
      this.userMessages = [];
    }

    else {

      this.submitQuestionnaireAnswersRequestModel.Answers=this.entityRenewalQuestions.map(it => {
        let q = new QuestionnaireAnswerModel();
        q.Answer=it.Answer;
        q.QuestionID=it.QuestionID
        return q;
      });
      this.submitQuestionnaireAnswersRequestModel.Answers.forEach(it=>console.log(it));
      this.entityRenewalService.submitEntityQuestionnaire(this.submitQuestionnaireAnswersRequestModel).subscribe
      ((response : SubmitQuestionnaireAnswersResponseModel)=>{

        console.log("submit question response : ", response);
        response.UserMessages.forEach(el => this.userMessages.push(el));
        this.currentPageWatcher.sendUserMessages(this.userMessages);
        if (response.Summary == 0) {
          this.entityRenewalService.renewalWorkflowModel = response.Workflow;
           //save startFunction with updated workflow in localstorage
           this.startFunction.Workflow.CurrentStepIndex = (this.entityRenewalService.renewalWorkflowModel.CurrentStepIndex ? this.entityRenewalService.renewalWorkflowModel.CurrentStepIndex : null);
           this.startFunction.Workflow.WorkflowID = (this.entityRenewalService.renewalWorkflowModel.WorkflowID ? this.entityRenewalService.renewalWorkflowModel.WorkflowID : null);
           this.startFunction.Workflow.WorkflowDisplayName = (this.entityRenewalService.renewalWorkflowModel.WorkflowDisplayName ? this.entityRenewalService.renewalWorkflowModel.WorkflowDisplayName : null);
           this.startFunction.Workflow.Fees = (this.entityRenewalService.renewalWorkflowModel.Fees ? this.entityRenewalService.renewalWorkflowModel.Fees : null);
           for (let i = 0; i < this.entityRenewalService.renewalWorkflowModel.Steps.length; i++) {
             this.startFunction.Workflow.Steps[i].StepDisplayName = this.entityRenewalService.renewalWorkflowModel.Steps[i].StepDisplayName;
             this.startFunction.Workflow.Steps[i].StepMessage = this.entityRenewalService.renewalWorkflowModel.Steps[i].StepMessage;
             this.startFunction.Workflow.Steps[i].WorkflowStepStatus = this.entityRenewalService.renewalWorkflowModel.Steps[i].WorkflowStepStatus;
             this.startFunction.Workflow.Steps[i].WorkflowStepType = this.entityRenewalService.renewalWorkflowModel.Steps[i].WorkflowStepType;

           }
           this.storage.setStartFunctionData(this.startFunction);
          console.log("this.entityRenewalService.renewalWorkflowModel===========", this.entityRenewalService.renewalWorkflowModel)
         //redirect to entity corporation
         this.router.navigate(["/entityCorporation"]).then(()=>{
           this.startFunctionService.getNotifyStepInProgress().emit(true);
           this.entityRenewalService.getNotifyQuestionList().emit(this.entityRenewalQuestions);
           this.entityRenewalService.getNotifySubmitQuestionnaireAnswersResponseModel().emit(response);
           this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
           this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
           this.individualRenewalService.getNotifyIndividualQuestionList().emit(this.individualRenewalQuestions);
           this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);

         })
          this.userMessages = [];
        }
        if (response.Summary == 1) {
          $("html, body").animate({ scrollTop: 0 }, "slow");
          this.userMessages = [];
        }
        if (response.Summary == 2) {
          this.currentPageWatcher.displayUserMessage = true;
          this.router.navigate(["/home"]);
          this.userMessages = [];
        }
      })
    }
  }

  goBack() {
    this.router.navigate(["/entityRenewalQuestionnaire"]).then(() => {
      this.currentPageWatcher.clearUserMessage();
      this.currentPageWatcher.clearStepMessage();
      this.currentPageWatcher.clearHeaderContent();
      this.startFunctionService.getNotifyStepInProgress().emit(false);
      this.entityRenewalService.getNotifySelectInactiveOfficesToRenewResponseModel().emit(this.selectInactiveOfficesToRenewResponseModel);
      this.individualRenewalService.getNotifyIndividualCorporationStatusResponseModel().emit(this.individualCorporationStatusResponse);
      this.individualRenewalService.getNotifyIndividualQuestionnaireAnswersResponse().emit(this.submitQuestionnaireAnswersResponseModel);
    });
  }

  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
   this.goBack();

  }

  ngOnDestroy(): void {
    if (this.currentPageWatcher.displayUserMessage == false) {
      this.currentPageWatcher.clearUserMessage();
    }
    this.currentPageWatcher.clearStepMessage();
    this.currentPageWatcher.clearHeaderContent();
  }
}



// WEBPACK FOOTER //
// ./src/app/renewal/entity-renewal/questionnaire-verify-entity-renewal/questionnaire-verify-entity-renewal.component.ts